import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-photo-theme-preview',
  templateUrl: './photo-theme-preview.component.html',
  styleUrls: ['./photo-theme-preview.component.scss'],
})
export class PhotoThemePreviewComponent {
  @Input() currentUpload: string | ArrayBuffer;
  @Output() emitRemoveFile: EventEmitter<any> = new EventEmitter();

  constructor() {}

  emitClose(event) {
    this.emitRemoveFile.emit(event);
  }
}
